import router from '../../../router'

export default {
  SAVE_CREDENTIALS (state, user) {
    state.user = user
    state.current_unity = user.unity
    localStorage.setItem('access_token', user.access_token)
    localStorage.setItem('user', JSON.stringify(user))
    localStorage.setItem('is_admin', user.is_admin)
    router.push('/')
  },
  LOGOUT (state) {
    state.user = null
    localStorage.removeItem('access_token')
    localStorage.removeItem('user')
    localStorage.removeItem('is_admin')
    router.push('/login')
  },
  LOAD_USER_FROM_LOCAL_STORAGE (state) {
    state.user = JSON.parse(localStorage.user)
    state.current_unity = state.user.unity
  },
  CHANGE_CURRENT_UNITY (state, unity) {
    state.current_unity = unity
  },
  SAVE_LIST (state, accounts) {
    state.accounts = accounts
  },
  DELETE (state, account) {
    const index = state.accounts.items.indexOf(account)
    state.accounts.items.splice(index, 1)
  },
}
